import { Block as BlockIcon } from 'components/icons';
import { Tooltip } from 'components/ui/tooltip';

import { t } from 'utils/getTranslations';

const BlockedTag = () => {
    return (
        <Tooltip content={t('dashboard.tooltips.timecard-blocked-short')}>
            <div className="bg-grey-100 new:bg-danger-tint inline-flex h-8 items-center rounded-[20px] px-4 py-2">
                <BlockIcon className="text-fg-secondary new:text-danger-ink mr-2 text-[20px]" />
                <p className="text-body1 text-fg-secondary new:text-danger-ink font-bold">
                    {t('dashboard.timecard-blocked')}
                </p>
            </div>
        </Tooltip>
    );
};

export default BlockedTag;
